import React, { FC } from "react";
// utils
import { getClinicImagePath } from "src/utils/clinics";
import { calcAvgRating, calcReviewsCount } from "src/utils/reviews";
// theme
import {
  Wrapper,
  CloseIconWrapper,
  Row,
  InnerWrapper,
  NextImageWrapper,
  ClinicTitle,
  ClinicAddress,
  RatingCountText,
  RateText,
  Star,
} from "./styles";
import { CSSProperties } from "styled-components";

interface IMapClinicCardOwnProps {
  name: string;
  logo_url: string | null;
  address: string;
  data: {
    lat: number;
    lng: number;
  };
  rating: Array<{ score: number; amountOfRates: number }>;
  heightImage?: CSSProperties;
}

const MapClinicCard: FC<IMapClinicCardOwnProps> = ({
  name,
  logo_url,
  address,
  rating,
  heightImage,
}) => {
  const reviewsCount = calcReviewsCount(rating);
  const avgRating = Number(calcAvgRating(rating));

  return (
    <Wrapper>
      <CloseIconWrapper id="close-clinic-popup-button">
        <img src="/icons/close-black.svg" width={12} height={12} />
      </CloseIconWrapper>

      <InnerWrapper>
        <NextImageWrapper style={heightImage} bg={getClinicImagePath(logo_url)} />
        <ClinicTitle>{name}</ClinicTitle>
        <Row margin={`6px 0 0 0`}>
          {/*<Row margin={`6px 0 ${!!species?.length ? '20px' : '0'} 0`}>*/}
          <ClinicAddress>{address}</ClinicAddress>
          {!!reviewsCount && !!avgRating && (
            <>
              <Star />
              <RatingCountText>{avgRating}</RatingCountText>
            </>
          )}
        </Row>

        {/*{!!species?.length && (*/}
        {/*  <SpeciesList>*/}
        {/*    {species.map((item: string, idx: number) =>*/}
        {/*      <SpeciesItem key={item + idx}>{item}</SpeciesItem>)}*/}
        {/*  </SpeciesList>*/}
        {/*)}*/}
      </InnerWrapper>
    </Wrapper>
  );
};

export default MapClinicCard;
